import React from 'react';

import { useQuery } from '@tanstack/react-query';

import InnerLink from '../InnerLink';

export default function FetchableValue({ value, fetchOptions, link, row }) {
  const { data: fetchedValue } = useQuery({
    queryKey: [...fetchOptions.queryKey, value],
    queryFn: () => fetchOptions.queryFn(value),
    enabled: !!value,
  });

  if (typeof fetchedValue !== 'string') {
    return null;
  }

  if (link && link(row)) {
    return <InnerLink to={link(row)}>{fetchedValue}</InnerLink>;
  }

  return <div>{fetchedValue}</div>;
}
